<template>
<BootstrapDialog title="新增报名批次" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <form role="form">
		                <div class="form-group">
		                    <label><span style="color: red">*</span>批次名称</label>
		                    <input type="text"  v-model="model.mc" name="mc" v-validate="{required:true,max:200}" data-vv-as="批次名称" class="form-control" placeholder=""/>
		                    <span class="error_validate_msg"><em>{{ errors.first('mc') }}</em></span>
		                </div>
						<div class="form-group">
						    <label><span style="color: red">*</span>批次简介</label>
							<textarea class="form-control" rows="2" v-model="model.jj"></textarea>
						</div>
						<div class="form-group">
						    <label><span style="color: red">*</span>学历类型</label>
						    <select  class="form-control"  v-model="model.lx"  v-validate="{required:true}" data-vv-as="学历类型" name="lx" >
						        <option value="">-请选择-</option>
						        <option v-for="item in xllx" :key="item.value" :value="item.value">{{item.text}}</option>
						    </select>
						    <span class="error_validate_msg"><em>{{ errors.first('lx') }}</em></span>
						</div>
		            </form>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-primary" type="button" @click="save()">保存</button>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
    import {xllx} from '@/plugins/enums.js';
    /**
     * 职业鉴定-考试批次管理
     */
    export default {
        name:'YearBatchAdd',
		components: {
		},
        data:function(){
            return {
				xllx:xllx,
                model:{
					mc:'',
					jj:'',
					lx:''
                }
            }
        },
        created:function(){
			console.log('------xllx:',xllx);
        },
        methods:{
			reset:function(){
				this.model = {
					mc:'',
					lx:''
				};
			},
			async open(params){
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/inf/zcpc/xz',this.model).then(res=>{
                            if(res.data){
								this.$success('操作成功',()=>{
									this.close();
									this.$parent.search();//刷新列表
								});
                            }
                        });
                    }
                });
            }
        }

    }
</script>
